import { gql, type OperationVariables } from '@apollo/client';
import type IOpportunity from '@sharedInterfaces/IOpportunity';
import type { IOpportunityNew } from '@sharedInterfaces/IOpportunity';
import Opportunity from '@src/Objects/Opportunity';

import GraphQL from '../graphQL';

import { opportunityGql } from './getOpportunity';

const query = gql`
mutation createOpportunity($newOpportunity:OpportunityNew!) {
    createOpportunity(newOpportunity: $newOpportunity) 
    ${opportunityGql}
},
`;

export default async function createOpportunity(newOpportunity: IOpportunityNew): Promise<Opportunity> {
    const variables: OperationVariables = {
        newOpportunity: {
            ...newOpportunity,
            // Remove fields not defined in GraphQL schema
            shortDescription: undefined,
            category: undefined,
            roles: newOpportunity.roles.map((role) => ({
                title: role.title,
                id: role.id,
            })),
            primaryRole: newOpportunity.primaryRole
                ? {
                      title: newOpportunity.primaryRole.title,
                      id: newOpportunity.primaryRole.id,
                  }
                : undefined,
        },
    };
    return GraphQL.mutate<IOpportunity>(query, variables).then((result) => new Opportunity(result));
}
